module.exports = __webpack_public_path__ + "img/alfred.eae4e5e3.svg";